export default "__VITE_ASSET__D8iLr6p6__"